import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ChipsItem, Icon, Label } from '@atlas/ui';

import { CDN_TYPE_GAME, imageUrlCDN } from 'common/utils';
import {
  GAMES_IN_COLUMN_BY_SIZE,
  GAMES_IN_ROW_BY_SIZE,
  GAMES_IN_ROW_BY_SIZE_FOR_FULL_WIDTH,
} from 'components/Casino/constants';

import InfoGamesList from './InfoGamesList';

export const CasinoCategory = memo(function CasinoCategory({
  category: { gameCount, games, iconUrl, id, name },
  isFullWidth,
  showCategoryHandler,
  sliderSettings,
}) {
  const [isReady, setIsReady] = useState(false);
  const [showSlider, setShowSlider] = useState(false);
  const [swiper, setSwiper] = useState(null);
  const [isShowImg, toggleVisibilityImg] = useState(!!iconUrl);

  const prevSlide = () => swiper && swiper.slidePrev();
  const nextSlide = () => swiper && swiper.slideNext();
  const handleError = () => toggleVisibilityImg(false);

  useEffect(() => {
    const { size } = sliderSettings;
    const gamesLengthInRow = Math.ceil(games.length / GAMES_IN_COLUMN_BY_SIZE[size]);
    const gamesInRowBySize = isFullWidth
      ? GAMES_IN_ROW_BY_SIZE_FOR_FULL_WIDTH
      : GAMES_IN_ROW_BY_SIZE;
    const gamesInRow = gamesInRowBySize[size];

    setShowSlider(gamesInRow < gamesLengthInRow);
    setIsReady(true);
  }, [games.length, isFullWidth, sliderSettings]);

  return isReady ? (
    <div className="casino__category">
      <div className="casino__category__header">
        <div className="casino__category__name">
          {isShowImg && (
            <img
              alt={name}
              className="casino__category__icon"
              onError={handleError}
              role="presentation"
              src={`${encodeURI(imageUrlCDN(iconUrl, CDN_TYPE_GAME))}`}
            />
          )}
          <h2 className="casino__category__title">{name}</h2>
        </div>
        {showCategoryHandler && (
          <ChipsItem
            className="casino__category__view-all"
            label={
              <div className="casino__category__title__view">
                <Label className="casino__category__title__text" message="View_All" />
                <span>({gameCount})</span>
              </div>
            }
            onClick={showCategoryHandler(id)}
          />
        )}
        {showSlider && (
          <>
            <ChipsItem
              className="casino__category__slider-arrow arrow-left"
              label={<Icon name="arrow-left" />}
              onClick={prevSlide}
            />
            <ChipsItem
              className="casino__category__slider-arrow arrow-right"
              label={<Icon name="arrow-right" />}
              onClick={nextSlide}
            />
          </>
        )}
      </div>
      <InfoGamesList
        games={games}
        isFullWidth={isFullWidth}
        setSwiper={setSwiper}
        showSlider={showSlider}
        sliderSettings={sliderSettings}
      />
    </div>
  ) : null;
});

CasinoCategory.propTypes = {
  category: PropTypes.shape({
    gameCount: PropTypes.number,
    games: PropTypes.arrayOf(PropTypes.object),
    iconUrl: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,
  isFullWidth: PropTypes.bool,
  showCategoryHandler: PropTypes.func,
  sliderSettings: PropTypes.object,
};
